var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { CloneUtility } from '../../../utilities/clone';
import { computedFrom } from "aurelia-binding";
import { UnitOfWorkObserver } from "../../../utilities/unit-of-work-observer";
import { NotificationType } from '../../../services/basics/notification-client.service';
import { Messages } from "../../../configuration/event-messages.constants";
import { activationStrategy } from "aurelia-router";
import * as Enumerable from "linq";
import { Guid } from "../../../utilities/guid";
import { DialogServiceConstants } from "../../../constants/basics/dialog.constants";
var BaseEntity = /** @class */ (function () {
    function BaseEntity(router, bindingEngine, i18N, notificationService, eventAggregator) {
        this.router = router;
        this.bindingEngine = bindingEngine;
        this.i18N = i18N;
        this.notificationService = notificationService;
        this.eventAggregator = eventAggregator;
        this.steps = [];
        this.handlingUpdateCompleted = false;
    }
    Object.defineProperty(BaseEntity.prototype, "item", {
        get: function () {
            return this._item;
        },
        set: function (x) {
            this._item = x;
            this.onItemChanged();
        },
        enumerable: false,
        configurable: true
    });
    BaseEntity.prototype.onItemChanged = function () { };
    BaseEntity.prototype.determineActivationStrategy = function () {
        return activationStrategy.replace;
    };
    BaseEntity.prototype.dialogClose = function () { };
    BaseEntity.prototype.goToList = function () {
        if (this._params.isFromDialog) {
            this.dialogClose();
        }
        else {
            this.router.navigateToRoute(this.getListRoute());
        }
    };
    BaseEntity.prototype.goBack = function () {
        this.router.navigateBack();
    };
    BaseEntity.prototype.initializeItemOverride = function (newItem) {
    };
    BaseEntity.prototype.initializeItemOverrideForUpdate = function (newItem) {
    };
    BaseEntity.prototype.activate = function (params, navigationInstruction) {
        // this is done like this because of this bug
        // 4489 Individual - cannot create a new individual if i have an individual already opened
        this._params = params;
        this._navigationInstruction = navigationInstruction;
        this.onActivation();
        var id = Number(params.id);
        return this.getEntity(id);
    };
    BaseEntity.prototype.onActivation = function () {
    };
    BaseEntity.prototype.getEntity = function (id) {
        var _this = this;
        this.steps = [];
        return new Promise(function (resolve, reject) {
            _this.getEntityInternal(id, function (x) {
                resolve(x);
            }, reject);
        });
    };
    BaseEntity.prototype.getEntityInternal = function (id, resolve, reject) {
        var _this = this;
        if (id && id > 0) {
            this.getExistingEntity(id, resolve, reject);
        }
        else {
            this.isCreateScreen = true;
            var possiblePromiseItem = this.initializeItemForCreate();
            var func_1 = function (item) {
                item.identifier = Guid.generateGuid();
                _this.item = item;
                _this.clearChanges(function () {
                    _this.initializeItemOverride(_this.item);
                    _this.refreshSteps();
                    resolve();
                });
            };
            if (possiblePromiseItem instanceof Promise) {
                possiblePromiseItem.then(function (x) {
                    func_1(x);
                }).catch(function (ex) {
                    func_1(null);
                });
            }
            else {
                func_1(possiblePromiseItem);
            }
        }
    };
    BaseEntity.prototype.getExistingEntity = function (id, resolve, reject) {
        var _this = this;
        this.isCreateScreen = false;
        this.getItem(Number(id))
            .then(function (response) {
            _this.item = response;
            _this.refreshSteps();
            _this.clearChanges(function () {
                _this.initializeItemOverrideForUpdate(_this.item);
                resolve();
            });
        });
    };
    BaseEntity.prototype.stepsInitialized = function () {
    };
    BaseEntity.prototype.refreshSteps = function () {
        this.steps = this.getSteps();
        this.stepsInitialized();
    };
    BaseEntity.prototype.getPropertiesToSkip = function () {
        return [];
    };
    BaseEntity.prototype.arrayChangesInterceptor = function (arrayName, items, added) {
        return items;
    };
    BaseEntity.prototype.takeSnapshot = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.unitOfWorkObserver) {
                _this.changesIgnoreDefaults = JSON.stringify(_this.unitOfWorkObserver.getChanges());
            }
        });
    };
    BaseEntity.prototype.hasChangesIgnoreDefaults = function () {
        if (this.unitOfWorkObserver && this.hasChanges()) {
            var clone = CloneUtility.clone(this.unitOfWorkObserver.getChanges());
            var changesIgnoreDefaults = this.changesIgnoreDefaults ? JSON.parse(this.changesIgnoreDefaults) : {};
            delete changesIgnoreDefaults.entityType;
            delete changesIgnoreDefaults["identifier"];
            delete clone.entityType;
            delete clone.identifier;
            return JSON.stringify(changesIgnoreDefaults) != JSON.stringify(clone);
        }
        return false;
    };
    BaseEntity.prototype.canDeactivate = function () {
        return true;
    };
    BaseEntity.prototype.attached = function () {
        if (!this.isCreateScreen && this.unitOfWorkObserver) {
            this.unitOfWorkObserver.startTracking();
        }
        this.takeSnapshot();
    };
    BaseEntity.prototype.detached = function () {
        if (this.unitOfWorkObserver) {
            this.unitOfWorkObserver.dispose();
        }
    };
    BaseEntity.prototype.hasChanges = function () {
        return this.unitOfWorkObserver.hasChanges();
    };
    BaseEntity.prototype.getChanges = function () {
        this.unitOfWorkObserver.addChange("identifier", this.item.identifier, null);
        this.unitOfWorkObserver.addChange("entityType", this.item.entityType, null);
        return this.unitOfWorkObserver.getChanges();
    };
    BaseEntity.prototype.clearChanges = function (callback) {
        var _this = this;
        if (callback === void 0) { callback = null; }
        if (this.unitOfWorkObserver) {
            this.unitOfWorkObserver.clearChanges();
            this.changesIgnoreDefaults = "";
            this.unitOfWorkObserver.dispose();
        }
        setTimeout(function () {
            _this.unitOfWorkObserver = new UnitOfWorkObserver(_this.bindingEngine, _this.item, _this.getPropertiesToSkip(), _this.arrayChangesInterceptor);
            _this.unitOfWorkObserver.startTracking();
            if (callback)
                callback();
        });
    };
    BaseEntity.prototype.showValidationErrors = function (response, preffix) {
        if (preffix === void 0) { preffix = null; }
        var fullError = "";
        Enumerable.from(response.validationResult.errors).distinct(function (error) { return error.message; }).forEach(function (error) {
            fullError += error.message + "<br/>";
        });
        var message = preffix
            ? (preffix + "<br/>" + fullError)
            : fullError;
        this.notificationService.show("Validation Error!", message, NotificationType.Error);
        this.eventAggregator.publish(Messages.onValidated, response.validationResult);
    };
    BaseEntity.prototype.beforeSave = function (skipValidation, resolve) {
        resolve(true, null);
    };
    BaseEntity.prototype.save = function (item, dontHandleOnComplete, skipValidation) {
        var _this = this;
        if (dontHandleOnComplete === void 0) { dontHandleOnComplete = false; }
        if (skipValidation === void 0) { skipValidation = false; }
        return new Promise(function (resolve, reject) {
            _this.beforeSave(skipValidation, function (isValid, validations) {
                if (!isValid) {
                    _this.notificationService.show("Validation Error!", validations ? validations : "", NotificationType.Error);
                }
                else {
                    var confirmModel = {
                        headerTitle: "save-confirmation",
                        btnOkayText: "confirm-text",
                        btnNoText: "cancel-text",
                    };
                    require("../../../../../ClientApp/app/views/app/admin/dialogs/confirmation-dialog");
                    _this.dialogClientService.show(DialogServiceConstants.URLs.ConfirmationDialog, {
                        confirmModel: confirmModel,
                        save: function () { return new Promise(function (resolves, reject) {
                            _this.dialogClientService.hide();
                            setTimeout(function () {
                                if (_this.hasChanges()) {
                                    _this.saving = true;
                                    var isNew_1 = !(_this.getItemIdInternal() && _this.getItemIdInternal() > 0);
                                    _this.saveItem(_this.getItemIdInternal(), _this.getChanges()).then(function (response) {
                                        if (!skipValidation && response.validationResult && response.validationResult.hasError) {
                                            _this.showValidationErrors(response);
                                        }
                                        if (!response.validationResult ||
                                            (response.validationResult && !response.validationResult.hasError) ||
                                            !response.shouldRollbackChangesOnValidationError) {
                                            if (response.generatedId) {
                                                _this.generatedId = response.generatedId;
                                            }
                                            if (!dontHandleOnComplete) {
                                                _this.handleUpdateCompleted(response, isNew_1);
                                            }
                                        }
                                        _this.saving = false;
                                        resolve(function () { return _this.handleUpdateCompleted(response, isNew_1); });
                                    }).catch(function (response) {
                                        if (response.validationResult && response.validationResult.hasError) {
                                            _this.showValidationErrors(response);
                                        }
                                        else if (response.name == "CustomError") {
                                            _this.notificationService.show("Oops Error!", response.message, NotificationType.Error);
                                        }
                                        else if (!(response.content && response.content.exception)) {
                                            _this.notificationService.show("Oops Error!", _this.i18N.tr("error-updating-text"), NotificationType.Error);
                                        }
                                        _this.saving = false;
                                        resolve(null);
                                    });
                                }
                                else {
                                    _this.notificationService.show("No Changes", _this.i18N.tr("there-were-no-changes-to-save-text"), NotificationType.Info);
                                    resolve(null);
                                }
                            });
                        }); }
                    });
                }
            });
        });
    };
    BaseEntity.prototype.getDurationSuccessMessage = function (successMessage) {
        return 5000;
    };
    BaseEntity.prototype.handleUpdateCompleted = function (response, isNew) {
        var _this = this;
        this.handlingUpdateCompleted = true;
        this.changesIgnoreDefaults = "";
        var title = this.i18N.tr(isNew ? "created-successfully-text" : "updated-successfully-text");
        var description = response.successMessage ? response.successMessage : "";
        this.notificationService.show(title, description, NotificationType.Success, this.getDurationSuccessMessage(description));
        if (!this._params.id || this._params.id <= 0) {
            this.generatedId = response.generatedId;
            this.clearChanges();
            if (this._params.isFromDialog) {
                this.dialogClose();
            }
            else {
                this.navigateToNew(response.generatedId ? response.generatedId : response.id);
                this.handlingUpdateCompleted = true;
            }
        }
        else {
            this.getEntity(this.getItemIdInternal()).then(function (x) {
                _this.handlingUpdateCompleted = false;
            });
        }
    };
    BaseEntity.prototype.navigateToNew = function (id) {
        this.router.navigateToRoute(this.getUpdateRoute(), { id: id }, { replace: true });
    };
    BaseEntity.prototype.getItemIdInternal = function () {
        return this.generatedId && this.generatedId > 0 ? this.generatedId : (this.getItemId() ? this.getItemId() : 0);
    };
    BaseEntity.prototype.setItem = function () { };
    __decorate([
        computedFrom('_item'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], BaseEntity.prototype, "item", null);
    return BaseEntity;
}());
export { BaseEntity };
